import { DropdownItemRenderV2 } from "#src/commonV2/antdHelpers/DropdownItemRender";
import { DropdownRenderV2 } from "#src/commonV2/antdHelpers/DropdownRender";
import { TAILWIND_COLORS } from "#src/utils/common";
import { Dropdown, Tooltip } from "@lockerpm/design";
import { ChevronDown, HelpCircle } from "@untitled-ui/icons-react";
import { FormCoreInput } from "../core/CoreInput";
import { FormFieldWrapper } from "../helpers/FieldWrapper";
import { FormInputWrapper } from "../helpers/InputWrapper";
import { ReactNode } from "react";
import { IFormCoreDropdownProps, IFormCoreInputProps } from "../types";

export interface IFormInputLeadingDropdownProps
  extends IFormCoreInputProps,
    IFormCoreDropdownProps {
  id?: string;
  label: string;
  required?: boolean;
  errorText?: string | null;
  hint?: ReactNode;
  tooltip?: ReactNode;
}

export const FormInputLeadingDropdown = (
  props: IFormInputLeadingDropdownProps
) => {
  const syncWidthId = "leading-dropdown-" + props.id;

  return (
    <FormFieldWrapper
      label={props.label}
      requiredMark={props.required}
      error={props.errorText}
      hint={props.hint}
    >
      <FormInputWrapper
        id={syncWidthId}
        invalid={Boolean(props.errorText)}
        disabled={props.disabled}
      >
        <Dropdown
          menu={{
            items: props.options.map((item) => ({
              key: item.key,
              label: (
                <DropdownItemRenderV2
                  label={
                    <>
                      {item.leftIcon ? item.leftIcon : null}
                      {item.getLabel()}
                    </>
                  }
                  isSelected={item.key === props.selected.key}
                  compact
                />
              ),
            })),
            onClick: ({ key }) => {
              const selected = props.options.find((item) => item.key === key);
              if (selected) {
                props.onChangeSelected(selected);
              }
            },
          }}
          dropdownRender={(menu) => (
            <DropdownRenderV2 syncWidthId={syncWidthId}>
              {menu}
            </DropdownRenderV2>
          )}
          trigger={["click"]}
          disabled={props.disabled}
        >
          <div
            className={`flex justify-between items-center gap-1 text-md text-gray-v2-700 py-2 pl-3 min-w-[4.5rem] ${props.disabled ? "cursor-auto" : "cursor-pointer"}`}
          >
            {props.selected ? props.selected.getLabel() : <span />}
            <ChevronDown className="h-5 w-5 min-w-5 text-gray-v2-400" />
          </div>
        </Dropdown>
        <div className="flex items-center gap-2 pl-2.5 pr-3 py-2 flex-1">
          <FormCoreInput {...props} />
          {props.tooltip ? (
            <Tooltip
              color={TAILWIND_COLORS["gray-v2-900"]}
              title={
                <p className="text-xs text-white font-semibold text-center">
                  {props.tooltip}
                </p>
              }
            >
              <HelpCircle className="h-4 w-4 min-w-4 text-gray-v2-400 cursor-pointer" />
            </Tooltip>
          ) : null}
        </div>
      </FormInputWrapper>
    </FormFieldWrapper>
  );
};
